import React, { Suspense, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import { useQuery } from '@apollo/client';
import InlineFiltersProvider from 'contexts/InlineFilters.context';
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';
import CascadingFiltersSalesAndStockView from 'views/CascadingFiltersSalesAndStockView/CascadingFiltersSalesAndStockView';
import { RETAIL_SALES_MONTH_TO_DATE } from 'queries/RetailSalesMonthToDate';

const SalesAndStock = () => {
  const [isShowCascadingFilters, setIsShowCascadingFilters] = useState(false);
  const [page, setPage] = useState(0);
  const cascadingFiltersLocalRef = useRef([]);

  const { data: businessSalesMonthData } = useQuery(RETAIL_SALES_MONTH_TO_DATE, {
    variables: {
      filterAll: {},
      export: true,
    },
  });

  return (
    <InlineFiltersProvider>
      <Stack direction="row" gap={2} m={3} mr={0}>
        <Suspense fallback={<LoadingSpinner fullScreen />}>
          <Outlet context={{ page, setPage, isShowCascadingFilters, setIsShowCascadingFilters }} />
        </Suspense>
        {isShowCascadingFilters && (
          // TODO: need to find a cleaner way for this...
          <Box mt={-3} ml={-3}>
            <CascadingFiltersSalesAndStockView //TODO: Update component when implementing Cascading filter logic
              cascadingFiltersLocalRef={cascadingFiltersLocalRef}
              setPage={setPage}
              businessSalesMonthData={businessSalesMonthData}
            />
          </Box>
        )}
      </Stack>
    </InlineFiltersProvider>
  );
};

export default SalesAndStock;
